// removed by extract-text-webpack-plugin
module.exports = {"setDeliveryDateButton-desktop":"G9b5e9b","setDeliveryDateButton-mobile":"Gbfdcd9","fullWidth":"Gdaa739","mobile":"Gdefc27"};